/* eslint-disable max-classes-per-file */
import { getText } from '../internal/TextLabels'
import { format } from './format'

export class ProfileSettingsModel {
  constructor() {
    this.firstName = ''
    this.lastName = ''
    this.username = ''
    this.email = ''
    this.phoneNumber = ''
  }
}

const profileSettings = {
  firstName: 'firstName',
  lastName: 'lastName',
  username: 'username',
  email: 'email',
  phoneNumber: 'phoneNumber',
}

export class ProfileSettingsForm {
  constructor(role) {
    this.labels = {}
    this.type = {}
    this.format = {}
    this.fieldValidation = {}
    this.isRequired = {}

    this.labels[profileSettings.firstName] = getText('profile.firstName')
    this.type[profileSettings.firstName] = 'text'
    this.format[profileSettings.firstName] = format.string
    this.isRequired[profileSettings.firstName] = true

    this.labels[profileSettings.lastName] = getText('profile.lastName')
    this.type[profileSettings.lastName] = 'text'
    this.format[profileSettings.lastName] = format.string
    this.isRequired[profileSettings.lastName] = true

    this.labels[profileSettings.username] = getText('profile.userName')
    this.type[profileSettings.username] = 'text'
    this.format[profileSettings.username] = format.usernameOrEmail
    this.isRequired[profileSettings.username] = true

    this.labels[profileSettings.email] = getText('profile.email')
    this.type[profileSettings.email] = 'text'
    this.format[profileSettings.email] = format.email
    this.isRequired[profileSettings.email] = role === 'SUPER_USER'

    this.labels[profileSettings.phoneNumber] = getText('profile.phone')
    this.type[profileSettings.phoneNumber] = 'text'
    this.format[profileSettings.phoneNumber] = format.phone
    this.isRequired[profileSettings.phoneNumber] = role === 'SUPER_USER'
  }
}
